import { z } from 'zod';
import { CurrencySchema, MoneyStringSchema } from './money';

/** commission：推荐佣金结算入账；refund：已结算任务退款；topup：数字货币充值到账；topup_bonus：充值赠送（docs/14）；redeem：兑换码 */
export const LEDGER_TYPES = ['grant', 'deduct', 'reversal', 'reserve', 'release', 'settle', 'waive', 'commission', 'refund', 'topup', 'topup_bonus', 'redeem'] as const;
export type LedgerType = (typeof LEDGER_TYPES)[number];

export const QuotaSummarySchema = z.object({
  object: z.literal('quota'),
  currency: CurrencySchema,
  available: z.string(),
  reserved: z.string(),
  granted_total: z.string(),
  settled_total: z.string(),
  key: z
    .object({
      id: z.string(),
      total_remaining: z.string(),
      daily_remaining: z.string().nullable(),
    })
    .nullable(),
});
export type QuotaSummary = z.infer<typeof QuotaSummarySchema>;

export const LedgerEntrySchema = z.object({
  id: z.string(),
  type: z.enum(LEDGER_TYPES),
  amount: z.string(),
  currency: CurrencySchema,
  available_after: z.string(),
  reference_no: z.string().nullable(),
  task_id: z.string().nullable(),
  note: z.string().nullable(),
  created_at: z.string(),
});
export type LedgerEntry = z.infer<typeof LedgerEntrySchema>;

/** 管理端可见：额外包含内部备注与操作人 */
export const AdminLedgerEntrySchema = LedgerEntrySchema.extend({
  user_id: z.string(),
  user_email: z.string(),
  internal_note: z.string().nullable(),
  operator: z.string().nullable(),
  reverses_entry_id: z.string().nullable(),
  reversed: z.boolean(),
});
export type AdminLedgerEntry = z.infer<typeof AdminLedgerEntrySchema>;

export const QuotaGrantSchema = z.object({
  user_id: z.string(),
  amount: MoneyStringSchema,
  reference_no: z.string().min(1).max(64),
  public_note: z.string().max(200).optional(),
  internal_note: z.string().max(500).optional(),
});
export type QuotaGrant = z.infer<typeof QuotaGrantSchema>;

export const QuotaDeductSchema = QuotaGrantSchema;

export const QuotaReversalSchema = z.object({
  entry_id: z.string(),
  public_note: z.string().max(200).optional(),
  internal_note: z.string().max(500).optional(),
});

export const QuotaPreviewSchema = z.object({
  user_id: z.string(),
  user_email: z.string(),
  currency: CurrencySchema,
  available_before: z.string(),
  available_after: z.string(),
  duplicate_of: z.string().nullable(),
});
export type QuotaPreview = z.infer<typeof QuotaPreviewSchema>;
